// extracted by mini-css-extract-plugin
module.exports = {"header":"vehicle-image-top-bar_header__1GLDX"};